import React, { useState, useEffect } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/theme';
import UserMenu from './UserMenu';
import { API_ENDPOINTS } from '../config';

export default function Navbar() {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const colors = getThemeColors(isDark);
  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);

  // Fetch user and organization data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(API_ENDPOINTS.PROFILE, {
          method: 'GET',
          credentials: 'include',
        });
        
        if (res.ok) {
          const data = await res.json();
          setUserData(data.user);
          setOrgData(data.company);
        }
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };
    
    fetchData();
  }, []);

  const handleHelpClick = () => {
    // Build email body with user and organization details using i18n
    const emailBody = `${t('help.emailGreeting')}

${t('help.emailIntro')}

${t('help.emailUserDetails')}
- ${t('help.emailUserEmail')}: ${userData?.email || 'N/A'}
- ${t('help.emailUserId')}: ${userData?.id || 'N/A'}
- ${t('help.emailUserRole')}: ${userData?.role || 'N/A'}

${t('help.emailOrgDetails')}
- ${t('help.emailOrgName')}: ${orgData?.name || 'N/A'}
- ${t('help.emailOrgPIB')}: ${orgData?.pib || 'N/A'}
- ${t('help.emailOrgMB')}: ${orgData?.mb || 'N/A'}
- ${t('help.emailOrgAddress')}: ${orgData?.address || 'N/A'}
- ${t('help.emailOrgCity')}: ${orgData?.city || 'N/A'}
- ${t('help.emailOrgPostalCode')}: ${orgData?.postalCode || 'N/A'}
- ${t('help.emailOrgPhone')}: ${orgData?.phone || 'N/A'}
- ${t('help.emailOrgEmail')}: ${orgData?.email || 'N/A'}
- ${t('help.emailOrgWebsite')}: ${orgData?.website || 'N/A'}

`;

    // Create mailto link and open in new tab
    const mailtoLink = `mailto:nemanja@lizzardsolutions.com?subject=${encodeURIComponent(t('help.emailSubject'))}&body=${encodeURIComponent(emailBody)}`;
    window.open(mailtoLink, '_blank');
  };

  return (
    <nav style={{
      width: '100%',
      maxWidth: '100vw',
      background: colors.card,
      boxShadow: `0 2px 12px ${colors.shadow}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 2vw',
      height: 64,
      position: 'relative',
      zIndex: 2,
      transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
      boxSizing: 'border-box',
      overflow: 'visible',
    }}>
      {/* Logo */}
      <div style={{
        display: 'flex', 
        alignItems: 'center',
        flexShrink: 0,
        minWidth: 0,
        overflow: 'visible',
      }}>
        <i className="fas fa-exchange-alt" style={{fontSize: 32, color: colors.primary, marginRight: 10}}></i>
        <span style={{fontWeight: 800, fontSize: 22, color: colors.primary, letterSpacing: 1}}>Konverter</span>
      </div>
      {/* Right side: Help button and User Menu */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flexShrink: 0,
        position: 'relative',
        zIndex: 1001,
        overflow: 'visible',
      }}>
        {/* Help Button */}
        <button
          onClick={handleHelpClick}
          style={{
            background: colors.backgroundHover,
            border: `1px solid ${colors.border}`,
            borderRadius: '50%',
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: `0 1px 4px ${colors.shadow}`,
            transition: 'all 0.2s ease',
            flexShrink: 0,
          }}
          onMouseEnter={(e) => {
            e.target.style.background = colors.border;
            e.target.style.boxShadow = `0 2px 8px ${colors.shadowHover}`;
          }}
          onMouseLeave={(e) => {
            e.target.style.background = colors.backgroundHover;
            e.target.style.boxShadow = `0 1px 4px ${colors.shadow}`;
          }}
          aria-label={t('help.ariaLabel')}
          title={t('help.title')}
        >
          <i className="fas fa-question-circle" style={{fontSize: 20, color: colors.primary}}></i>
        </button>
        <UserMenu />
      </div>
    </nav>
  );
} 